import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Button from './button';
import Icon from './icon';
import styles from '../scss/modules/components/button.icon.module.scss';
export default (props) => {
    const iconContent = props.children.split(' ').map((x) => _jsx(Icon, { children: x }));
    if (props.href !== undefined) {
        return _jsx(_Fragment, { children: _jsx("a", { href: props.href, target: props.target, rel: props.rel, className: `${styles.iconButton} ${props.color === 'invisible' ? 'invisible' : styles[props.color]} ${props.muted && styles.muted}`, onClick: props.onClick, title: props.title, children: iconContent }) });
    }
    else {
        return _jsx(_Fragment, { children: _jsx(Button, { icon: true, submit: props.submit, color: props.color, muted: props.muted, onClick: props.onClick, title: props.title, disabled: props.disabled, children: iconContent }) });
    }
};
